import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import * as ac from "./action-creators";
import { INITIAL_FILTERS_PANEL_STATE } from "./constants";
import type { AdvancedSearchFilteringState } from "./types";

const INITIAL_STATE: AdvancedSearchFilteringState = {
    isNewOnly: false,
    filtersPanel: INITIAL_FILTERS_PANEL_STATE,
};

const advancedSearchFilteringReducer = createReducer<AdvancedSearchFilteringState, ActionType<typeof ac>>(INITIAL_STATE)
    .handleAction(
        ac.updateIsNewOnlyAction,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            isNewOnly: payload,
        }),
    )
    // Filters panel state
    .handleAction(
        ac.setSelectedFilterCategory,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                selectedFilterCategory: payload,
                searchQuery: INITIAL_FILTERS_PANEL_STATE.searchQuery,
            },
        }),
    )
    .handleAction(
        ac.setIsFiltersCategoriesPanelExpanded,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                isFiltersCategoriesPanelExpanded: payload,
                searchQuery: INITIAL_FILTERS_PANEL_STATE.searchQuery,
                ...(!payload
                    ? {
                          selectedFilterCategory: INITIAL_FILTERS_PANEL_STATE.selectedFilterCategory,
                          expandedFilter: INITIAL_FILTERS_PANEL_STATE.expandedFilter,
                      }
                    : {}),
            },
        }),
    )
    .handleAction(
        ac.setIsFiltersPanelExpanded,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                isFiltersPanelExpanded: payload,
            },
        }),
    )
    .handleAction(
        ac.setExpandedFilterName,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                expandedFilter: payload,
            },
        }),
    )
    .handleAction(
        ac.setFilterMode,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                filterMode: payload,
            },
        }),
    )
    .handleAction(
        ac.setSearchQuery,
        (state, { payload }): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                searchQuery: payload,
                expandedFilter:
                    payload.length > 0 && state.filtersPanel.searchQuery.length === 0
                        ? INITIAL_FILTERS_PANEL_STATE.expandedFilter
                        : state.filtersPanel.expandedFilter,
            },
        }),
    )
    .handleAction(
        ac.markInitialFiltersReady,
        (state): AdvancedSearchFilteringState => ({
            ...state,
            filtersPanel: {
                ...state.filtersPanel,
                isInitialFiltersReady: true,
            },
        }),
    )
    .handleAction(ac.resetFilteringStateAction, (): AdvancedSearchFilteringState => INITIAL_STATE);

export default advancedSearchFilteringReducer;
